export async function submitLsQuiz({ payload, token }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/submitLsQuiz`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || "Failed to submit quiz");
  }

  return resp.json();
}
